module.exports = __webpack_public_path__ + "img/afrika_nap_plakat.d4c89c3a.jpg";